export const emailVerificationInitialState = {
  isReSendingEmail: false
}

export type EmailVerificationState = typeof emailVerificationInitialState
